<div class="shell-banners">

  <div class="lifeislife-shell-banner" *ngIf="(activeBanner$ | async)">
    <div class="banner" [@bannerIn]="true">
      <span class="message">{{ (activeBanner$ | async).message}}</span>
      <span class="lifeislife-link-toolbar">
        <a *ngFor="let action of (activeBanner$ | async).actions"
           (click)="fireAction(action,$event)">
          {{ action.message }}
        </a>
      </span>
    </div>
  </div>

</div>
